export const GALLERY = {
  FETCH_GALLERY_PAGE: {
    MAIN: 'FETCH_GALLERY_PAGE',
    SUCCESS: 'FETCH_GALLERY_PAGE_SUCCESS',
    FAILURE: 'FETCH_GALLERY_PAGE_FAILURE'
  }
}
